// extracted by mini-css-extract-plugin
export default {"container":"NaoEncontrada_container__PIuu2","icone":"NaoEncontrada_icone__y92MY"};